// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ContactType, ContactTypeSchema } from 'api/gen/ContactType';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ContactValue, ContactValueSchema } from 'api/gen/ContactValue';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

const requiredPart = t.interface({
  contactType: ContactTypeSchema,
  userProfileId: PositiveIntegerSchema,
  value: ContactValueSchema,
});

export const NewUserProfileContactSchema = excess(requiredPart);

export interface NewUserProfileContact extends t.TypeOf<typeof NewUserProfileContactSchema> {}
